import React from 'react';

import { Helpers } from '../../core/src/helpers';
import CartButton from '../../shared/components/cart-button';
import { Carousel } from '../../shared/components/carousel';
import NavArrow from '../../shared/components/nav-arrow';
import XSellProduct from './origin-xsell-product';
import { filterCategories, sortCategories } from '../xsell-actions';

import '../css/tabs-xsell-modal.less';

const EMPTY_OBJECT = {};

class TabsXSellBundleTestModal extends React.Component {

    constructor(props) {
        super(props);

        let { xSellProductList } = this.props;
        let categories = this.generateCategories(xSellProductList);

        this.state = {
            activeTab: 'Most Popular',
            skusAdded: [],
            categories
        }
    }

    closeModal = () => {
        this.props.closeXSellModal();
    }

    handleAddandRemove = (action, sku) => {
        if (action === 'add') {
            this.setState({
                skusAdded: [...this.state.skusAdded, sku]
            })
        } else if (action === 'remove') {
            this.setState({
                skusAdded: this.state.skusAdded.filter((prodSku) => prodSku !== sku)
            })
        }
    }

    //function to check if the category has bundle offers, specific to bundle test
    getBundleOffer(sku, categoryName, offers) {
        //check if category is in offers
        const categoryOffers = offers[categoryName.toLowerCase()];
        if (!categoryOffers) {
            return '';
        }
        //check if category has multiple tiers of discounts, if it does, there should be a 'keys' field, with its value being an array of keys
        const hasMultipleDiscounts = categoryOffers.hasOwnProperty('multipleTiers');
        if (!hasMultipleDiscounts) {
            if (sku in categoryOffers.skus) {
                return categoryOffers.discount;
            }
        } else {
            for (var key in categoryOffers.skus) {
                if (sku in categoryOffers.skus[key]) {
                    return categoryOffers.discount;
                }
            }
            return '';
        }
        return '';
    }

    //function to get bundle sale price, specific to bundle test
    getSalePrice = (prod) => {
        const { sku='', bundleDiscount } = prod;
        const { prices } = this.props;
        return ((prices[sku] || EMPTY_OBJECT).salePrice || prod.salePrice) * (1 - bundleDiscount)
    }

    //function get price prop to pass to the Price component, specific to bundle test
    getPriceProps = (prod) => {
        const { sku='' } = prod;
        const { prices } = this.props;
        
        let regularPrice = (prices[sku] || EMPTY_OBJECT).regularPrice || prod.listPrice;
        let finalPrice;

        if (prod.bundleDiscount) {
            finalPrice = this.getSalePrice(prod)
        } else {
            finalPrice = ((prices[sku] || EMPTY_OBJECT).salePrice || prod.salePrice);
        }

        return {
            price: { regularPrice, salePrice: this.validateNum(finalPrice) },
            spClassName: 'sale-price',
            showListPrice: regularPrice > finalPrice,
            showSalePrice: true
        };
    }

    validateNum = (num) => {
        if (isNaN(num)) {
            return '';
        }
        return num;
    }

    //function to generate categories specific to bundle discounts
    generateBundleCategories(products) {
        let bundleDiscount;
        let categoriesObj = {};
        let categoriesInOffer;
        const { offers, product } = this.props;
        const { isSmb, name } = product;
        let services = [];
        categoriesObj = products.reduce((categories, prod) => {
            for (let i = 0; i < prod.categories.length; i++) {
                const categoryName = this.changeCategoryName(prod.categories[i].displayName);
                const location = prod.categories[i].location;

                if (!prod.bundleDiscount) {
                    if (isSmb === 'Yes') {
                        bundleDiscount = this.getBundleOffer(prod.sku, categoryName, offers.commercial);
                        categoriesInOffer = categoryName.toLowerCase() in offers.commercial; 
                    } else {
                        bundleDiscount = this.getBundleOffer(prod.sku, categoryName, offers.consumer);
                        categoriesInOffer = categoryName.toLowerCase() in offers.consumer; 
                    }
                    prod.bundleDiscount = bundleDiscount;
                }

                if (this.props.dir === 'pdp' && categoryName === 'Services') {
                    services.push(product);
                } else if (categoryName.toLowerCase().indexOf('dlp') < 0 &&
                           (categoryName.match(/care pack/gi) === null) &&
                           (product.isSmb === 'Yes' || categoryName.match(/service/gi) === null) &&
                           (location.indexOf('<<') > -1 || 
                            categoryName.toLowerCase() === 'most popular' || 
                            categoryName.toLowerCase() === 'business solutions')
                )
                {
                    prod.displayCategory = categoryName;
                    if (categoryName in categories) {
                        if (categories[categoryName].products.filter((prd) => prd.sku === prod.sku).length === 0) {
                            categories[categoryName].products.push(prod);
                        }
                    } else {
                        categories[categoryName] = { 
                            products: [prod],
                            displayName: categoryName,
                            id: prod.categories[i]._id,
                            selected: false
                        }
                    }    
                }
            }
            return categories;
        }, {})
        if(services.length > 0) {
            categoriesObj['Services'] = services;
        }
        filterCategories(categoriesObj);
        return sortCategories(categoriesObj, name, isSmb);
    }

    changeCategoryName(name){
        if(name === 'All') {
            return 'Most Popular';
        }
        if(name === 'Ink & Toner') {
            return 'Ink, Toner & Paper';
        }
        return name;
    }

    changeTab = (tabName) => {
        this.setState({ activeTab: tabName })
    }

    controls(type) {
        if (type === 'category') {
            return {
                slidesToShow: 6,
                slidesToScroll: 6,
                renderCenterLeftControls : NavArrow.PrevArrow,
                renderCenterRightControls: NavArrow.NextArrow,
                renderBottomCenterControls: () => <div></div>
            }
        } else if (type === 'product') {
            return {
                slidesToShow: 3,
                slidesToScroll: 3,
                renderCenterLeftControls : NavArrow.PrevArrow,
                renderCenterRightControls: NavArrow.NextArrow,
            }
        }
    }

    render() {
        const { product, cartItems, getProductClickMetrics } = this.props;
        const { categories, activeTab, skusAdded } = this.state;
        const { name, isSmb, sku } = product;
        const isProductPC = Helpers.isProductPC(product);
        const catSettings = {
            ...this.controls('category'),
        };
        const prodSettings = {
            ...this.controls('product'),
        };
        let date = new Date('12/1/2020');
        const title = new Date() > date ? 'Get <b>15%</b> off select accessories and <b>10%</b> off select monitors with purchase of PC. <br/>Limit one per category type.' : 'Get <b>15%</b> off select accessories and monitors with purchase of PC. <br/>Limit one per category type.';

        const content = Object.keys(categories).length > 0 && categories.constructor === Object ? 
        <div>
            <div className="modal-header-wrapper">
                <span className="header-name">{name}</span> has been added to cart.
            </div>
                <div dangerouslySetInnerHTML={Helpers.createMarkup(title)} className={`sub-header${isSmb === 'Yes' ? ' business' : ' consumer'}${isProductPC ? ' pc' : ''} bundle-test-var1`}></div>
            <div className='xsell-category-list'>
                <Carousel className='xsell-category-carousel' {...catSettings} ref={carousel => this.carousel = carousel}>
                    {(Object.keys(categories) || []).map((category, i) => {
                        return (
                        <div className={category === activeTab ? 'active-tab tab' : 'tab'} key={i} onClick={() => this.changeTab(category)}>
                            <div className={`hp-icon default ${categories[category].displayName.toLowerCase().replace(/ |, /g, '-').replace(/\&/g, 'and')}`}></div>
                            <span>{category}</span>
                        </div>
                        )
                    })}
                </Carousel>
            </div>
            <div className="xsell-category-products">
                <Carousel className='xsell-category-carousel' {...prodSettings} ref={carousel => this.carousel = carousel}>
                    {((categories[activeTab] || {}).products || []).slice(0, 6).map((prod, i) => {
                        return <XSellProduct
                                    key={i}
                                    baseProductSku={sku} 
                                    product={prod}
                                    xsellTemplate={'tabs'}
                                    handleAddandRemove={this.handleAddandRemove}
                                    added={skusAdded.indexOf(prod.sku) > -1}
                                    cartItems={cartItems}
                                    priceProps={this.getPriceProps(prod)}
                                    isBundleTest={this.props.enabled}
                                    productClickMetrics={typeof getProductClickMetrics === 'function' ? getProductClickMetrics({product: prod, position: i+1 }) : null}
                                    ctaMetrics={ctaMetrics}
                                />
                    })}
                </Carousel>
            </div>
            <CartButton
                buttonText={'Continue to cart'}
                className={'tabs-xsell-modal'}
            />
        </div> : null;
        return content;
    }
};

export default TabsXSellBundleTestModal;